// extracted by mini-css-extract-plugin
module.exports = {"loader":"Button_loader__2E38o","loading":"Button_loading__1Mm1M","hidden":"Button_hidden__1B_Uk"};